import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col px-8 py-2" }
const _hoisted_3 = { class: "card flex justify-content-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white" }, "N.Y.H", -1)
const _hoisted_5 = { class: "flex flex-column gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "dte",
  class: "font-bold text-white"
}, "Date", -1)
const _hoisted_7 = { class: "flex flex-column gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "results",
  class: "font-bold text-white"
}, "Numbers", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", null, "Enter the results separate by comma. ex: 1,2,3", -1)

import Button from "primevue/button";
import Calendar from "primevue/calendar";
import env from "@/env.json";
import InputText from "primevue/inputtext";
import { useToast } from "primevue/usetoast";
import { useNyhForm } from "./composables/useNyhForm";


export default /*#__PURE__*/_defineComponent({
  __name: 'NyhForm',
  setup(__props) {

const toast = useToast();

const { dte, results, dteInvalid, resultsInvalid, loading, onSubmit } = useNyhForm(toast);

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => _unref(onSubmit)(_unref(env).API_URL), ["prevent"])),
          class: "flex flex-column gap-2"
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_unref(Calendar), {
              id: "dte",
              class: _normalizeClass({ 'p-invalid': _unref(dteInvalid) }),
              modelValue: _unref(dte),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dte) ? (dte).value = $event : null)),
              dateFormat: "dd/mm/yy",
              maxDate: new Date(),
              showIcon: "",
              showButtonBar: ""
            }, null, 8, ["class", "modelValue", "maxDate"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createVNode(_unref(InputText), {
              id: "results",
              class: _normalizeClass({ 'p-invalid': _unref(resultsInvalid) }),
              type: "text",
              modelValue: _unref(results),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(results) ? (results).value = $event : null))
            }, null, 8, ["class", "modelValue"]), [
              [
                _directive_tooltip,
                'Enter the results separate by comma. ex: 1,2,3',
                void 0,
                { top: true }
              ]
            ]),
            _hoisted_9
          ]),
          _createVNode(_unref(Button), {
            type: "submit",
            label: "Submit",
            icon: "pi pi-check",
            severity: "success",
            loading: _unref(loading),
            raised: ""
          }, null, 8, ["loading"])
        ], 32)
      ])
    ])
  ]))
}
}

})